export interface User {
	userId: number;
	userName: string;
	userIsAdmin: boolean;
	userIsVendorAdmin: boolean;
	userIsVendorUser: boolean;

	loginError?: string;
	loggedIn: boolean;
}

export function isUser(data: any): data is User {
	return (
		data &&
		typeof data === "object" &&
		typeof data.userId === "number" &&
		typeof data.userName === "string" &&
		typeof data.userIsAdmin === "boolean" &&
		typeof data.userIsVendorAdmin === "boolean" &&
		typeof data.userIsVendorUser === "boolean"
	);
}
